import { render, staticRenderFns } from "./knowledgDetail.vue?vue&type=template&id=be0d6c8e&scoped=true&"
import script from "./knowledgDetail.vue?vue&type=script&lang=js&"
export * from "./knowledgDetail.vue?vue&type=script&lang=js&"
import style0 from "./knowledgDetail.vue?vue&type=style&index=0&id=be0d6c8e&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0d6c8e",
  null
  
)

export default component.exports